import React from "react";
import { useThemeProvider } from "../../providers/ThemeProvider";

export const WaveShapeComponent = ({ position = "left" }) => {
  const theme = useThemeProvider();
  return (
    <div
      className={theme.styles.classes.componentsShapeWave1}
      style={
        position === "left"
          ? {
              left: 0,
            }
          : position === "right"
          ? {
              right: 0,
            }
          : {}
      }
    >
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 300 300"
        fill="rgba(200,200,200, 40%)"
        style={
          position === "left"
            ? {
                transform: "translateX(-50%)",
                opacity: 0.3,
              }
            : position === "right"
            ? {
                transform: "translateX(50%)",
                opacity: 0.3,
              }
            : {}
        }
      >
        <g className="st0">
          <path
            className="st1"
            d="M47.5,251.7l68.6,39.1c12.3,7,27.1,3.8,33.6-7.4l20.9-35.7c7.7-13.1,26.5-14.8,38.9-3.5l0,0
              c15.6,14.3,39.4,7.3,41.8-12.2l4.7-39.3c0.3-2.4,0.9-4.7,1.9-6.8c8.1-17.4,13.2-34.5,16.3-47.1c2.7-11.1-3-23.4-13.8-29.5
              l-76.4-43.4c-4.1-2.3-7.7-5.7-10.2-9.7l-26.5-41.6c-10-15.7-32-18-42.3-4.4L89.6,30.7c-9.9,13.1-21.5,24.9-34.5,35L27.3,87.4
              c-8.6,6.7-10.9,18.7-5.8,29.3l16.1,32.9c5,10.3,3,21.9-5.1,28.7L15,193c-11.9,10-10,29.3,3.9,39.4l10.4,7.5
              C35.1,244.2,41.2,248.1,47.5,251.7z"
          />
        </g>
        <g className="st2">
          <path
            className="st1"
            d="M137.2,288.5l36.2-9.1c6.3-1.6,11.1-6.6,12.3-13l4.6-23.1c1.4-7.1,7.3-12.5,14.5-13.4l20.8-2.4
              c6.9-0.8,12.6-5.8,14.3-12.5l12.1-47.9c1.9-7.4,8.6-12.6,16.2-12.6h0c10.2,0,18-9,16.6-19.1l-4.6-32.5c-0.5-3.3,0-6.6,1.4-9.6
              l5.7-11.9c5.3-11.1-2.8-23.9-15.1-23.9H215c-4.6,0-9-1.9-12.1-5.2l-27.8-29.3c-3.6-3.8-8.7-5.7-13.8-5.1l-69.7,7.1
              c-1.3,0.1-2.6,0.1-3.9-0.1l-41.6-5.5c-9.7-1.3-18.5,6.1-18.9,15.9L24.2,106c-0.1,1.3-0.3,2.7-0.6,3.9l-13,44.6
              c-1.6,5.6-0.2,11.7,3.8,16l45.2,49.2c4.3,4.7,5.6,11.3,3.3,17.3l-11,29.4c-4.1,11,4,22.7,15.7,22.7h65.6
              C134.5,289,135.8,288.8,137.2,288.5z"
          />
        </g>
        <g className="st3">
          <path
            className="st1"
            d="M100.4,6.7l170.1,68.6c24.6,9.9,31.4,42.1,13,61.5L142.8,284.5c-17.5,18.3-47.4,14.2-59.4-8.3L10.5,139.8
              c-6.1-11.4-6-25.1,0.2-36.4l43.5-79.9C63.3,6.9,83.1-0.3,100.4,6.7z"
          />
        </g>
      </svg>
    </div>
  );
};

export const WaveCenterShapeComponent = ({ position = "left" }) => {
  const theme = useThemeProvider();
  return (
    <div
      className={theme.styles.classes.componentsShapeWave2}
      style={
        position === "left"
          ? {
              left: "50%",
            }
          : position === "right"
          ? {
              right: "50%",
            }
          : {}
      }
    >
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 300 300"
        fill="rgba(200,200,200, 40%)"
        style={
          position === "left"
            ? {
                opacity: 0.3,
              }
            : position === "right"
            ? {
                opacity: 0.3,
              }
            : {}
        }
      >
        <g className="st0">
          <path
            className="st1"
            d="M47.5,251.7l68.6,39.1c12.3,7,27.1,3.8,33.6-7.4l20.9-35.7c7.7-13.1,26.5-14.8,38.9-3.5l0,0
              c15.6,14.3,39.4,7.3,41.8-12.2l4.7-39.3c0.3-2.4,0.9-4.7,1.9-6.8c8.1-17.4,13.2-34.5,16.3-47.1c2.7-11.1-3-23.4-13.8-29.5
              l-76.4-43.4c-4.1-2.3-7.7-5.7-10.2-9.7l-26.5-41.6c-10-15.7-32-18-42.3-4.4L89.6,30.7c-9.9,13.1-21.5,24.9-34.5,35L27.3,87.4
              c-8.6,6.7-10.9,18.7-5.8,29.3l16.1,32.9c5,10.3,3,21.9-5.1,28.7L15,193c-11.9,10-10,29.3,3.9,39.4l10.4,7.5
              C35.1,244.2,41.2,248.1,47.5,251.7z"
          />
        </g>
        <g className="st2">
          <path
            className="st1"
            d="M137.2,288.5l36.2-9.1c6.3-1.6,11.1-6.6,12.3-13l4.6-23.1c1.4-7.1,7.3-12.5,14.5-13.4l20.8-2.4
              c6.9-0.8,12.6-5.8,14.3-12.5l12.1-47.9c1.9-7.4,8.6-12.6,16.2-12.6h0c10.2,0,18-9,16.6-19.1l-4.6-32.5c-0.5-3.3,0-6.6,1.4-9.6
              l5.7-11.9c5.3-11.1-2.8-23.9-15.1-23.9H215c-4.6,0-9-1.9-12.1-5.2l-27.8-29.3c-3.6-3.8-8.7-5.7-13.8-5.1l-69.7,7.1
              c-1.3,0.1-2.6,0.1-3.9-0.1l-41.6-5.5c-9.7-1.3-18.5,6.1-18.9,15.9L24.2,106c-0.1,1.3-0.3,2.7-0.6,3.9l-13,44.6
              c-1.6,5.6-0.2,11.7,3.8,16l45.2,49.2c4.3,4.7,5.6,11.3,3.3,17.3l-11,29.4c-4.1,11,4,22.7,15.7,22.7h65.6
              C134.5,289,135.8,288.8,137.2,288.5z"
          />
        </g>
        <g className="st3">
          <path
            className="st1"
            d="M100.4,6.7l170.1,68.6c24.6,9.9,31.4,42.1,13,61.5L142.8,284.5c-17.5,18.3-47.4,14.2-59.4-8.3L10.5,139.8
              c-6.1-11.4-6-25.1,0.2-36.4l43.5-79.9C63.3,6.9,83.1-0.3,100.4,6.7z"
          />
        </g>
      </svg>
    </div>
  );
};
